import { utils } from "../../utils/Utils";
import axios from "axios";

Window.PUBLIC_APIURL = "https://api.vagaro.com";
//Window.PUBLIC_APIURL = "https://stage-api.bookitall.com";

async function PublicAsyncAjaxPost(Url, data, access_token, callback, onFailure, merchantid, userid) {
  let Group = localStorage.getItem('Group')
  if (!utils.Validate(Group)) {
    Group = "us02";
  }
  if (utils.Validate(Group)) {
    window.VagaroPublicApiUrl = Window.PUBLIC_APIURL + "/" + Group + "/api/v2/";
  }
  else {
    window.VagaroPublicApiUrl = Window.PUBLIC_APIURL + "/api/v2/";
  }
  const APIURL = window.VagaroPublicApiUrl + Url;
  let header = {
    "Content-Type": "application/json",
    //"Authorization": "Bearer " + access_token,
    ...(utils.Validate(merchantid) && {'merchantId' : merchantid}),
    ...(utils.Validate(userid) && {'userId' : userid}),
  };
  await axios.post(APIURL, data, { headers: header })
    .then((response) => { callback(response) })
    .catch((error) => { onFailure(error) });
};

async function PublicAsyncAjaxGet(Url, access_token, callback, onFailure, merchantid, userid) {
  let Group = localStorage.getItem('Group')
  if (!utils.Validate(Group)) {
    Group = "us02";
  }
  if (utils.Validate(Group)) {
    window.VagaroPublicApiUrl = Window.PUBLIC_APIURL + "/" + Group + "/api/v2/";
  }
  else {
    window.VagaroPublicApiUrl = Window.PUBLIC_APIURL + "/api/v2/";
  }
  const APIURL = window.VagaroPublicApiUrl + Url;
  let header = {
    "Content-Type": "application/json",
    //"Authorization": "Bearer " + access_token,
    ...(utils.Validate(merchantid) && {'merchantId' : merchantid}),
    ...(utils.Validate(userid) && {'userId' : userid}),
  };
  await axios.get(APIURL, { headers: header })
    .then((response) => { callback(response) })
    .catch((error) => { onFailure(error) });
};

async function PublicAjaxGenerateToken(Url, data, callback, onFailure) {
  let Group = localStorage.getItem('Group')
  if (!utils.Validate(Group)) {
    Group = "us02";
  }
  if (!utils.Validate(Group)) {
    Group = "us02";
  }
  if (utils.Validate(Group)) {
    window.VagaroPublicApiUrl = Window.PUBLIC_APIURL + "/" + Group + "/api/v2/";
  }
  else {
    window.VagaroPublicApiUrl = Window.PUBLIC_APIURL + "/api/v2/";
  }
  const APIURL = window.VagaroPublicApiUrl + Url;
  const header = {
    "Content-Type": "application/json",
  };
  await axios.post(APIURL, data, { headers: header })
    .then((response) => { callback(response) })
    .catch((error) => { onFailure(error) });
};

export { PublicAsyncAjaxPost, PublicAsyncAjaxGet, PublicAjaxGenerateToken };
